import * as types from '../constants/recipe-cart';
import localStorage from 'store';

let initialState = {
  isLoading: false,
  items: localStorage.get('recipe_cart_items') || [],
  data: [],
  pharmacyOffers: [],
  selectedOffer: null,
  orderCompleted: false,
  location: localStorage.get('cart_location') || {
    name: 'Киев',
    latitude: 50.4501,
    longitude: 30.5234,
  },
  mapCenter: localStorage.get('cart_location') || {
    latitude: 50.4501,
    longitude: 30.5234,
  },
  vErrors: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_EHEALTH_RECIPE_START:
      return {
        ...state,
        isLoading: true,
      };
    case types.GET_EHEALTH_RECIPE_SUCCESS:
      return {
        ...state,
        isLoading: true,
        data: payload,
      };
    case types.GET_EHEALTH_RECIPE_FAILURE:
      return {
        ...state,
        isLoading: true,
        data: [],
      };
    case types.GET_EHEALTH_DRUGSTORES_START:
      return {
        ...state,
        isLoading: true,
        pharmacyOffers: [],
      };
    case types.GET_EHEALTH_DRUGSTORES_SUCCESS:
      return {
        ...state,
        pharmacyOffers: payload,
        isLoading: false,
      };
    case types.GET_EHEALTH_DRUGSTORES_FAILURE:
      return {
        ...state,
        pharmacyOffers: [],
        isLoading: false,
      };
    case types.ADD_TO_CART:
      return {
        ...state,
        items: payload,
      };
    case types.SELECT_OFFER:
      return {
        ...state,
        selectedOffer: payload,
      };
    case types.SET_V_ERRORS:
      return {
        ...state,
        vErrors: payload,
      };
    case types.STORE_ORDER_SUCCESS:
      return {
        ...state,
        order: payload,
        selectedOffer: null,
        pharmacyOffers: [],
        isLoading: false,
        orderCompleted: true,
      };
    case types.STORE_ORDER_FAILURE:
      return {
        ...state,
        isLoading: true,
      };
    case types.SET_LOADER: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    case types.FLUSH_CONFIRM: {
      return {
        ...state,
        orderCompleted: false,
      };
    }
    case types.FLUSH_ALL:
      return {
        ...state,
        selectedOffer: null,
        pharmacyOffers: [],
        items: [],
      };
    default:
      return state;
  }
};
